import React from "react";
import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";
import remarkBreaks from "remark-breaks";

const normalizeMarkdownText = (input) => {
    if (input == null) return "";

    return String(input)
        .replace(/\r\n/g, "\n")
        .replace(/\r/g, "\n")
        .trim();
};

export default function RichDescription({ text }) {
    // const safeText = normalizeMarkdownText(text);
    const safeText = text;

    if (!safeText) return null;

    return (
        <div
            className="
                prose prose-sm prose-slate max-w-none
                dark:prose-invert

                prose-headings:scroll-mt-24
                prose-headings:font-semibold
                prose-p:my-2
                prose-p:leading-relaxed
                prose-ul:my-2
                prose-ol:my-2
                prose-li:my-0.5
                prose-table:my-4
                prose-th:border
                prose-th:border-slate-300
                prose-th:bg-slate-100
                prose-th:px-3
                prose-th:py-2
                prose-td:border
                prose-td:border-slate-200
                prose-td:px-3
                prose-td:py-2
                dark:prose-th:border-slate-700
                dark:prose-th:bg-slate-800
                dark:prose-td:border-slate-700
            "
        >
            <ReactMarkdown
                remarkPlugins={[remarkGfm, remarkBreaks]}
                components={{
                    img: ({ src, alt }) => (
                        <img
                            src={src || ""}
                            alt={alt || ""}
                            loading="lazy"
                            className="
                                my-4
                                block
                                max-w-full
                                h-auto
                                rounded-xl
                                border
                                border-slate-200
                                object-contain
                                dark:border-slate-700
                            "
                        />
                    ),

                    a: ({ href, children }) => (
                        <a
                            href={href || "#"}
                            target="_blank"
                            rel="noreferrer"
                            className="break-words"
                        >
                            {children}
                        </a>
                    ),

                    pre: ({ children }) => (
                        <pre
                            className="
                                my-4
                                rounded-2xl
                                bg-[#111321]
                                px-4
                                py-3
                                text-xs
                                font-mono
                                leading-relaxed
                                text-slate-50
                                overflow-x-auto
                                shadow-sm
                                border
                                border-slate-800
                            "
                        >
                            {children}
                        </pre>
                    ),

                    code: ({ inline, children, ...props }) => {
                        if (inline) {
                            return (
                                <code
                                    className="
                                        rounded-md
                                        bg-slate-100
                                        px-1.5
                                        py-0.5
                                        text-[0.75rem]
                                        font-mono
                                        text-slate-800
                                        dark:bg-slate-800/70
                                        dark:text-slate-100
                                    "
                                    {...props}
                                >
                                    {children}
                                </code>
                            );
                        }

                        return (
                            <code
                                className="font-mono text-[0.75rem]"
                                {...props}
                            >
                                {children}
                            </code>
                        );
                    },

                    p: ({ children }) => (
                        <p className="text-sm leading-relaxed text-slate-800 dark:text-slate-100">
                            {children}
                        </p>
                    ),

                    li: ({ children }) => (
                        <li className="text-sm leading-relaxed text-slate-800 dark:text-slate-100">
                            {children}
                        </li>
                    ),

                    blockquote: ({ children }) => (
                        <blockquote
                            className="
                                my-4
                                border-l-4
                                border-slate-300
                                bg-slate-50
                                px-4
                                py-2
                                text-sm
                                italic
                                text-slate-700
                                dark:border-slate-600
                                dark:bg-slate-900/60
                                dark:text-slate-300
                            "
                        >
                            {children}
                        </blockquote>
                    ),

                    table: ({ children }) => (
                        <div className="my-4 overflow-x-auto">
                            <table className="min-w-full border-collapse text-sm">
                                {children}
                            </table>
                        </div>
                    ),
                }}
            >
                {safeText}
            </ReactMarkdown>
        </div>
    );
}